import React, { useState } from 'react';
import { Copy } from 'lucide-react';
import { useLocale } from '../../../contexts/LocaleContext';

export default function CopyButton({ text }) {
  const { t } = useLocale();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      onClick={handleCopy}
      className="p-1 rounded hover:bg-[var(--bg-secondary)] text-[var(--text-tertiary)] hover:text-[var(--text-secondary)] transition-smooth"
      aria-label={t('common.copyToClipboard')}
    >
      <Copy className={`w-3.5 h-3.5 ${copied ? 'text-green-500' : ''}`} />
    </button>
  );
}